/* eslint-disable @next/next/no-img-element */

type NavigationMenuItemType = {
  icon?: string;
  image?: string;
  selected: boolean;
  folded?: boolean;
  label?: string; //folded=false일 때 나타남
  onClick?: () => void;
};

// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=1887-1171&t=3lunUvpzgaQBTI5S-4
const NavigationMenuItem = (props: NavigationMenuItemType) => {
  const { icon, image, selected, folded = true, label = "", onClick } = props;

  if (folded)
    return (
      <div
        className={`navigation-menu-item ${selected ? "selected" : ""}`}
        onClick={onClick}
      >
        {icon && <i className={icon} style={{ fontSize: 24 }} />}
        {image && <img src={image} alt={image} width={24} height={24} />}
      </div>
    );

  return (
    <div
      className={`navigation-menu-item folded-false ${selected ? "selected" : ""}`}
      onClick={onClick}
    >
      {icon && <i className={icon} style={{ fontSize: 24 }} />}
      {image && <img src={image} alt={image} width={24} height={24} />}
      <span className="body2-700">{label}</span>
    </div>
  );
};

export { NavigationMenuItem };
